import { isNotEmpty } from './validation'

export const removeFullMediaUrlProperties = (documents) => {
  if(isNotEmpty(documents)) {
    documents.map(document => delete document?.full_media_url)
  } 
  return documents
}